module.exports = __webpack_public_path__ + "img/cross.302d5770.svg";